import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campaigns, Campus, Consentement, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { campaigns, consent, defaultValues, getCampus } from "services"
import Cursus from "../components/Cursus"
import Programme from "../components/Programme"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('EART-JPO')
  const { url: url_contact } = useUrlReturn('EART-CONTACT')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      cursus: '',
      cycle: '',
      lead: {
        ...defaultValues,
        Master__c: false,
        PGE__c: false,
        Salutation: '',
        Section__c: '',
        Speciality__c: '',
        Undecided__c: false
      },
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = {
      ...data.lead,
      Speciality__c: data.lead.Speciality__c === 'hesite' ? '' : data.lead.Speciality__c
    }
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'e-artsup',
      IONISSchool__c: 'e-artsup',
      LeadSource: campaignId !== 'unavailable' ? `JPO` : 'Demande de rendez-vous',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      // const leadCreated = await salesforce.createLead(finalLead)
      if (campaignId !== 'unavailable') {
        // const campaignMember = {
        //   CampaignId: campaignId,
        //   LeadId: leadCreated.Id,
        //   Status: 'Registered'
        // }
        // await salesforce.createCampaignMember(campaignMember)
        await submission({
          formId: 'JPO',
          lead: finalLead,
          campaignId: campaignId,
          campaignStatus: 'Registered',
          utmCookieName: '_ionis_user_data' // optionnel
        })
        document.location.href=`${url}?ville=${campus}&campaignId=${campaignId}`
      } else {
        let description = ''

        if (data.availabilities.type === 'Être rappelé(e) sur Skype') {
          description = 'ID Skype : ' + data.availabilities.skypeId + '\n\n'
        }
        description += data.availabilities.dates.join(', ')

        const subject = data.availabilities.type
        await submission({
          formId: 'CONTACT',
          lead: finalLead,
          subject: subject,
          description: description,
          utmCookieName: '_ionis_user_data' // optionnel
        })
        // const task = {
        //   ActivityDate: new Date(),
        //   Description: description,
        //   OwnerId: leadCreated.OwnerId,
        //   Subject: subject,
        //   WhoId: leadCreated.Id
        // }

        // await salesforce.createTask(task)
        document.location.href=`${url_contact}?ville=${campus}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('BusinessSchoolLead')

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Campus label="Ville choisie pour participer à la Journée Portes Ouvertes" options={getCampus('e-artsup')} />
        <Campaigns contact={false} division="e-artsup" last_form="JPO" school="e-artsup" text="à la Journée Portes Ouvertes" textAvailability="pour nos journées portes ouvertes" type="JPO" />
        <Cursus />
        <Programme />
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone mobile" required />
        </Grid>
        <AcademicLevel school="e-artsup" section={false} specialites={false} />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Journée Portes Ouvertes" school="e-artsup" />
      </Grid>
    </FormProvider>
  )
}

export default Form
